import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

/****
 * @type {{showLogin: boolean, currentRoute: string, balance: {}, showLoginEmail: boolean, gameInfo: {showIframe: boolean}, showLoading: boolean, loginStatus: string, userName: (default.methods.userName|string), internation: (string|string), showWinner: boolean}}
 * 2021-09-28 CHP 增加showLoginEmail
 * 2021-10-31 CHP 增加国际版本、提款验证相关函数和属性
 */
const state = {
  fbCid: ['9af1ep'],
  showLoading: false,
  showLogin: false,
  showLoginEmail: false,
  loginStatus: 'login',
  currentRoute: '',
  balance: {},
  userName: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).UserName : '',
  showWinner: true,
  gameInfo: {
    showIframe: false
  },
  bankList: [],
  internation: localStorage.getItem('internation') ? localStorage.getItem('internation') : 'IN',
  internationName: localStorage.getItem('internationName') ? localStorage.getItem('internationName') : 'भारत',
  locale: localStorage.getItem('locale') ? localStorage.getItem('locale') : 'EN',
  showInternationDDL: false,
  verifyInfo: null,
  showPopupDownApp: false, // for popping up hint img window of downloading app,by HHY 20220526
  banUserId: ['bab76a51bd0a449ca925e1912b6c2582', 'ff63299d59e747b1adeed7579c7353e7']
}

const mutations = {
  toggleLoading (state, showLoading) {
    state.showLoading = showLoading
    return state.showLoading
  },
  toggleLogin (state, showLogin) {
    console.log(state.internation)
    switch (state.internation) {
      case 'IN':
        state.showLogin = showLogin
        break
      case 'INT':
        state.showLoginEmail = showLogin
    }
    return showLogin
  },
  setUserBankList (state, bankList) {
    state.bankList = bankList
    return state.bankList
  },
  toggleLoginEmail (state, showLoginEmail) {
    state.showLoginEmail = showLoginEmail
    return state.showLoginEmail
  },
  setCurrentRoute (state, type) {
    state.currentRoute = type
    return state.currentRoute
  },
  setBalance (state, balance) {
    state.balance = balance
    return state.balance
  },
  updateUserName (state, userName) {
    state.userName = userName
    return state.userName
  },
  setShowWinner (state, showWinner) {
    state.showWinner = showWinner
    return state.showWinner
  },
  setGameInfo (state, gameInfo) {
    state.gameInfo = gameInfo
    return state.gameInfo
  },
  // 2021-08-29 CHP 设置国家代码
  setInternation (state, internation) {
    state.internation = internation
    localStorage.setItem('internation', internation)
    return state.internation
  },
  // 2021-10-25 CHP 设置国家名称
  setInternationName (state, internationName) {
    state.internationName = internationName
    localStorage.setItem('internationName', internationName)
    return state.internation
  },
  // 2021-10-25 CHP 设置国家语言
  setLocale (state, locale) {
    state.locale = locale
    localStorage.setItem('locale', locale)
    return state.locale
  },
  setLoginStatus (state, loginStatus) {
    state.loginStatus = loginStatus
    return state.loginStatus
  },
  setShowInternationDDL (state, showInternationDDL) {
    state.showInternationDDL = showInternationDDL
    localStorage.setItem('showInternationDDL', showInternationDDL)
    return state.showInternationDDL
  },
  setUserVerifyInfo (state, verifyInfo) {
    state.verifyInfo = verifyInfo
    return state.verifyInfo
  }
}

export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/store.js